import { useIntl } from "@components/Intl"
import { LabelS } from "@components/Typography"
import { getGraphQLClient } from "@lib/graphql-client"
import { useQuery } from "@tanstack/react-query"
import { FC } from "react"
import { Product } from "./product"

type PopularProductsProps = {
  items: string[]
}
const { sdk } = getGraphQLClient()

export const PopularProducts: FC<PopularProductsProps> = ({ items }) => {
  const { locale } = useIntl()
  const articleCombinationsIds = items.filter((item) => item.length <= 4)
  const articleIds = items.filter((item) => item.length > 4)
  const { data: articleCombinationData } = useQuery(
    ["articleCombinations", articleCombinationsIds],
    () => sdk.ArticleCombinationsById({ ids: articleCombinationsIds })
  )
  const { data } = useQuery(["articles", articleIds], () =>
    sdk.ArticlesById({ ids: articleIds })
  )

  const hasArticleCombinations =
    articleCombinationData &&
    articleCombinationData.choicesArticleCombinationsById
  const hasArticles = data && data.choicesArticlesById

  return hasArticleCombinations || hasArticles ? (
    <>
      <LabelS style={{ fontSize: 14 }} mb="1rem">
        {locale === "nl" ? "Populaire producten" : "Popular products"}
      </LabelS>
      {hasArticleCombinations &&
        articleCombinationData.choicesArticleCombinationsById.map((article) => (
          <Product {...article} key={article.id} type="article-combination" />
        ))}
      {hasArticles &&
        data.choicesArticlesById.map((article) => (
          // @ts-ignore
          <Product
            {...article}
            product_group={article.component}
            key={article.id}
            type="single-product"
          />
        ))}
    </>
  ) : null
}
